import createIcon from '../../createIcon';

/**
 * @component @name Filter9Plus
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA1SDFWMjFDMSAyMi4xIDEuOSAyMyAzIDIzSDE5VjIxSDNWNVpNMTQgMTJWOEMxNCA2Ljg5IDEzLjEgNiAxMiA2SDExQzkuOSA2IDkgNi44OSA5IDhWOUM5IDEwLjExIDkuOSAxMSAxMSAxMUgxMlYxMkg5VjE0SDEyQzEzLjEgMTQgMTQgMTMuMTEgMTQgMTJaTTExIDlWOEgxMlY5SDExWk0yMSAxSDdDNS45IDEgNSAxLjkgNSAzVjE3QzUgMTguMSA1LjkgMTkgNyAxOUgyMUMyMi4xIDE5IDIzIDE4LjEgMjMgMTdWM0MyMyAxLjkgMjIuMSAxIDIxIDFaTTIxIDlIMTlWN0gxN1Y5SDE1VjExSDE3VjEzSDE5VjExSDIxVjE3SDdWM0gyMVY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Filter9Plus = createIcon('Filter9Plus', [
  [
    'path',
    {
      d: 'M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM14 12V8C14 6.89 13.1 6 12 6H11C9.9 6 9 6.89 9 8V9C9 10.11 9.9 11 11 11H12V12H9V14H12C13.1 14 14 13.11 14 12ZM11 9V8H12V9H11ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 9H19V7H17V9H15V11H17V13H19V11H21V17H7V3H21V9Z',
      key: '1tc917',
    },
  ],
]);

export default Filter9Plus;
